import endOfMonth from 'date-fns/endOfMonth';
import endOfWeek from 'date-fns/endOfWeek';
import format from 'date-fns/format';
import startOfMonth from 'date-fns/startOfMonth';
import startOfWeek from 'date-fns/startOfWeek';

import { useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';

import { ReceiptApi } from '../api';
import { ClientCalendar } from '../components/organisms/ClientCalendar';
import { useAuthContext } from '../hooks';
import type { Receipt } from '../model';

export const ClientCalendarPage = () => {
  const { isAuthorized } = useAuthContext();
  const [anchorDate, setAnchorDate] = useState<Date>(new Date());
  const viewStart = useMemo(
    () => startOfWeek(startOfMonth(anchorDate), { weekStartsOn: 1 }),
    [anchorDate],
  );
  const viewEnd = useMemo(
    () => endOfWeek(endOfMonth(anchorDate), { weekStartsOn: 1 }),
    [anchorDate],
  );
  const [receipts, setReceipts] = useState<Receipt[]>([]);
  const [selectedWeekIndex, setSelectedWeekIndex] = useState<number>(0);
  useQuery({
    queryKey: [ReceiptApi.KEY, 'get', viewStart, viewEnd],
    queryFn: () =>
      ReceiptApi.get({
        date_from: viewStart ? format(viewStart, 'dd-MM-yyyy') : undefined,
        date_to: viewEnd ? format(viewEnd, 'dd-MM-yyyy') : undefined,
      }),
    enabled: isAuthorized && Boolean(viewStart && viewEnd),
    onSuccess(receipts) {
      setReceipts(receipts);
    },
  });

  return (
    <ClientCalendar
      anchorDate={anchorDate}
      onDateChange={(date) => {
        setAnchorDate(date);
        setSelectedWeekIndex(0);
      }}
      receipts={receipts}
      selectedWeekIndex={selectedWeekIndex}
      onSelectWeek={setSelectedWeekIndex}
    />
  );
};
